import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { createDataSondage, getSondage } from "../api";
import "../../styles/Contact.css";
import Loading from "../Loading.js";
import { LanguageValue } from "../../context/LanguageValue";
import { RedirectUrlValue } from "../../context/RedirectUrlValue";
import { SondageStar } from "./SondageStar.js";
import { useModuleData } from "./UseModuleData.js";
import PopupMerci from "../popup/Merci.js";
import imageCompression from "browser-image-compression";

export default function Sondage() {
    const { state } = useLocation();
    const { language } = useContext(LanguageValue);
    const { brand } = useContext(RedirectUrlValue);

    const { module, clientData, languageData, loading, error } = useModuleData(
        brand,
        language,
        state?.module,
    );

    const [valueSondage, setValueSondage] = useState(0);
    const [result, setResult] = useState([]);
    const [animationClass, setAnimationClass] = useState("");
    const [isComplet, setIsComplet] = useState(false);
    const [isStart, setIsStart] = useState(false);
    const [formData, setFormData] = useState({
        nom: "",
        email: "",
        entreprise: "",
        Boutique: "",
        note: "",
    });
    const [theme, setTheme] = useState("");
    const [image, setImage] = useState(null);
    const [showPopupMerci, setShowPopupMerci] = useState(false);
    const [totalResultData, setTotalResultData] = useState([]);
    const [totalResultDataTheme, setTotalResultDataTheme] = useState([]);

    useEffect(() => {
        if (
            module?.dataQuestion &&
            result.length === module.dataQuestion.length
        ) {
            console.log(result);
        }
    }, [result, module?.dataQuestion]);

    useEffect(() => {
        if (module.client && module.client !== "Richemont") {
            setFormData((prev) => ({
                ...prev,
                Boutique: "value",
            }));
        }
    }, [module]);

    useEffect(() => {
        if (!formData.Boutique) return;

        getSondage().then((data) => {
            const themes = data
                .filter((item) => item.data[0].Boutique === formData.Boutique)
                .map((item) => item.data[0].theme);

            setTotalResultDataTheme(themes); // tableau de tous les thèmes
        });
    }, [formData]);

    useEffect(() => {
        getSondage().then((data) => {
            const countsByBoutique = {};

            data.forEach((item) => {
                const boutique = item.data[0].Boutique;
                const theme = item.data[0].theme;

                if (theme === "Note") return;

                if (!countsByBoutique[boutique]) {
                    countsByBoutique[boutique] = new Set();
                }

                countsByBoutique[boutique].add(theme);
            });

            const resultTable = Object.entries(countsByBoutique).map(
                ([boutique, themes]) => ({
                    Boutique: boutique,
                    Occurrences: themes.size,
                }),
            );

            setTotalResultData(resultTable);
        });
    }, [formData]);

    if (loading) return <Loading />;
    if (error) return <p>Une erreur est survenue : {error.message}</p>;

    const handleSubmit = async () => {
        const filteredData = Object.fromEntries(
            Object.entries(formData).filter(
                ([_, value]) => value.trim() !== "",
            ),
        );

        try {
            await createDataSondage({
                result: result,
                ...filteredData,
                client: module.client,
                theme: theme,
                image: image,
                Boutique: formData.Boutique,
                note: formData.note,
                entreprise: formData.entreprise,
                email: formData.email,
                nom: formData.nom,
            });
            console.log("Sondage créé avec succès");
        } catch (error) {
            alert("Erreur lors de la création du sondage");
            console.error(error);
        }
        setIsStart(false);
        setIsComplet(false);
        setResult([]);
        setValueSondage(0);
        setFormData((prev) => ({
            nom: "",
            email: "",
            entreprise: "",
            note: "",
            Boutique: prev.Boutique,
        }));
        setTheme("");
        setImage(null);
        setShowPopupMerci(true);
    };

    const handleLog = (key) => {
        setValueSondage(module.dataQuestion[key].data);
        setTheme(module.dataQuestion[key].title);
        setIsStart(true);
        if (module.dataQuestion[key].data.length === 0) {
            setIsComplet(true);
        }
    };

    const handleNoPopup = () => {
        setShowPopupMerci(false);
    };

    const handleImageChange = async (file) => {
        if (!file) return;

        const options = {
            maxSizeMB: 3, // Taille max en Mo
            maxWidthOrHeight: 1024, // Résolution max
            useWebWorker: true,
        };

        try {
            const compressedFile = await imageCompression(file, options);
            setImage(compressedFile); // Tu envoies ça au backend
        } catch (error) {
            console.error("Compression échouée", error);
        }
    };

    return (
        <div className="SondagePage" style={{ overflow: "hidden" }}>
            {showPopupMerci && (
                <div className="popups">
                    <div
                        onClick={() => handleNoPopup()}
                        className="shadow"
                    ></div>
                    <div className="radiusBorder">
                        <PopupMerci setShowPopupMerci={setShowPopupMerci} />
                    </div>
                </div>
            )}
            <div
                id="slideSondagePage"
                className={`page WiewState ${animationClass}`}
            >
                {result.length <= valueSondage.length - 1 ? (
                    <div className="titleSondage">
                        {module.client === "Richemont" ? (
                            <p className="theme">
                                <span>Boutique : </span>
                                {formData.Boutique}
                            </p>
                        ) : null}
                        <p>
                            <span>Thème : </span>
                            {theme}
                        </p>
                    </div>
                ) : (
                    <p></p>
                )}
                <div className="Question">
                    {
                        isStart && valueSondage ? (
                            !isComplet ? (
                                valueSondage.map((item, index) => (
                                    <p
                                        key={index}
                                        id={index}
                                        className={
                                            result.length === index
                                                ? "activeQuestion"
                                                : "question"
                                        }
                                    >
                                        {item}
                                    </p>
                                ))
                            ) : null
                        ) : (
                            /* Module commence ICI */
                            <>
                                {module.client === "Richemont" ? (
                                    <div className="merci">
                                        <label>
                                            Sélectionnez votre boutique
                                        </label>
                                        <select
                                            value={formData.Boutique}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    Boutique: e.target.value,
                                                })
                                            }
                                            name="site"
                                            id="site"
                                        >
                                            <option value="" disabled>
                                                Sélectionnez votre boutique
                                            </option>
                                            {Object.entries(
                                                module.BoutiqueSelection,
                                            ).map(([ville, noms]) => (
                                                <optgroup
                                                    key={ville}
                                                    label={ville}
                                                >
                                                    {noms.map((nom, key) => {
                                                        const fullName = `${nom} ${ville}`;
                                                        const item =
                                                            totalResultData.find(
                                                                (el) =>
                                                                    el.Boutique ===
                                                                    fullName,
                                                            );

                                                        const count = item
                                                            ? item.Occurrences
                                                            : 0;

                                                        return (
                                                            <option
                                                                className={
                                                                    count === 0
                                                                        ? "uncompletedOption"
                                                                        : count >=
                                                                            5
                                                                          ? "completedOption"
                                                                          : "inProgressOption"
                                                                }
                                                                key={key}
                                                                value={fullName}
                                                            >
                                                                {`${
                                                                    count === 0
                                                                        ? "❌"
                                                                        : count <=
                                                                            4
                                                                          ? count +
                                                                            "/5"
                                                                          : "✅"
                                                                } ${nom} ${ville}`}
                                                            </option>
                                                        );
                                                    })}
                                                </optgroup>
                                            ))}
                                        </select>
                                    </div>
                                ) : null}

                                {formData.Boutique && module?.dataQuestion && (
                                    <div className="moduleContainer">
                                        {Object.keys(module.dataQuestion).map(
                                            (key) => (
                                                <div
                                                    onClick={() =>
                                                        handleLog(key)
                                                    }
                                                    className={
                                                        totalResultDataTheme.includes(
                                                            module.dataQuestion[
                                                                key
                                                            ].title,
                                                        ) &&
                                                        module.dataQuestion[key]
                                                            .title !== "Note"
                                                            ? "module moduleCompleted"
                                                            : "module"
                                                    }
                                                    key={key}
                                                >
                                                    <p
                                                        style={{
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        {key}
                                                    </p>
                                                    <div className="line"></div>
                                                    <img
                                                        src={
                                                            module.dataQuestion[
                                                                key
                                                            ].imgUrl
                                                        }
                                                        alt={key}
                                                    />
                                                </div>
                                            ),
                                        )}
                                    </div>
                                )}
                            </>
                        )
                        /* Module commence ICI */
                    }
                </div>

                <div className="ratingStar">
                    {isStart && valueSondage ? (
                        isComplet ? (
                            module.client === "Richemont" ? (
                                languageData ? (
                                    <div className="noteContainer">
                                        <div>
                                            <label>Note</label>
                                            <textarea
                                                placeholder="Saisisez vos note"
                                                name="note"
                                                className="note"
                                                value={formData.note}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        note: e.target.value,
                                                    })
                                                }
                                            ></textarea>
                                            <label
                                                htmlFor="fileUpload"
                                                className={
                                                    image
                                                        ? "buttonImage selected"
                                                        : "buttonImage"
                                                }
                                            >
                                                {image
                                                    ? "Image sélectionnée ✅"
                                                    : "Sélectionner un image"}
                                            </label>{" "}
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                style={{ display: "none" }}
                                                onChange={(e) =>
                                                    handleImageChange(
                                                        e.target.files[0],
                                                    )
                                                }
                                            />
                                        </div>
                                        <div
                                            style={{
                                                backgroundColor:
                                                    clientData?.couleur,
                                            }}
                                            onClick={handleSubmit}
                                            className="activeButton"
                                        >
                                            {languageData.demandeDeService.send}
                                        </div>
                                    </div>
                                ) : (
                                    <Loading />
                                )
                            ) : (
                                <div className="merci">
                                    <input
                                        type="text"
                                        name="nom"
                                        placeholder={
                                            `${
                                                languageData.demoContact.formNom
                                            }` +
                                            ", " +
                                            `${languageData.demoContact.formPrenom}`
                                        }
                                        value={formData.nom}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                nom: e.target.value,
                                            })
                                        }
                                    />
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder={
                                            languageData.demoContact.formEmail
                                        }
                                        value={formData.email}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                email: e.target.value,
                                            })
                                        }
                                    />
                                    <input
                                        type="text"
                                        name="entreprise"
                                        placeholder={
                                            languageData.demoContact
                                                .formEntreprise
                                        }
                                        value={formData.entreprise}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                entreprise: e.target.value,
                                            })
                                        }
                                    />

                                    {languageData ? (
                                        <div
                                            style={{
                                                backgroundColor:
                                                    clientData?.couleur,
                                            }}
                                            onClick={handleSubmit}
                                            className="activeButton"
                                        >
                                            {languageData.demandeDeService.send}
                                        </div>
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            )
                        ) : (
                            <SondageStar
                                // saveProgress={createDataSondage}
                                setValueSondage={setValueSondage}
                                setAnimationClass={setAnimationClass}
                                setIsComplet={setIsComplet}
                                valueSondage={valueSondage}
                                setResult={setResult}
                                result={result}
                                module={module}
                            />
                        )
                    ) : (
                        <></>
                    )}
                </div>

                {isComplet ? null : isStart && valueSondage ? (
                    <div className="progressionBarContainer">
                        <div className="ProgressionBarBackground">
                            <p>
                                {result.length + 1} / {valueSondage.length}
                            </p>
                        </div>
                        <div
                            style={{
                                width: `${
                                    ((result.length + 1) /
                                        valueSondage.length) *
                                    100
                                }%`,
                            }}
                            className="ProgressionBar"
                        ></div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
